import client from "./client";

const getProducts = () => client.get("/subsidiary/dashboard/product/all");

export default { getProducts };
